import { useEffect } from 'react';
import { X, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

const Toast = ({ message, type = 'info', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle size={20} />,
    error: <AlertCircle size={20} />,
    warning: <AlertTriangle size={20} />,
    info: <Info size={20} />,
  };

  const colors = {
    success: {
      bg: 'var(--success-50)',
      border: 'var(--success-200)',
      text: 'var(--success-800)',
      icon: 'var(--success-600)',
    },
    error: {
      bg: 'var(--danger-50)',
      border: 'var(--danger-200)',
      text: 'var(--danger-800)',
      icon: 'var(--danger-600)',
    },
    warning: {
      bg: 'var(--warning-50)',
      border: 'var(--warning-200)',
      text: 'var(--warning-800)',
      icon: 'var(--warning-600)',
    },
    info: {
      bg: 'var(--primary-50)',
      border: 'var(--primary-200)',
      text: 'var(--primary-800)',
      icon: 'var(--primary-600)',
    },
  };

  const style = colors[type] || colors.info;

  return (
    <div className="toast-container">
      <div className="toast" style={{
        backgroundColor: style.bg,
        borderColor: style.border,
        color: style.text,
      }}>
        <div className="toast-icon" style={{ color: style.icon }}>
          {icons[type]}
        </div>
        <div className="toast-message">
          {message}
        </div>
        <button className="toast-close" onClick={onClose} style={{ color: style.text }}>
          <X size={16} />
        </button>
      </div>

      <style jsx>{`
        .toast-container {
          position: fixed !important;
          top: 20px !important;
          right: 20px !important;
          z-index: 99999 !important;
          animation: slideIn 0.3s ease-out;
          pointer-events: auto !important;
        }

        .toast {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border-radius: var(--radius-lg);
          border: 1px solid;
          box-shadow: var(--shadow-lg);
          min-width: 300px;
          max-width: 500px;
          animation: slideIn 0.3s ease-out;
        }

        .toast-icon {
          flex-shrink: 0;
        }

        .toast-message {
          flex: 1;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .toast-close {
          flex-shrink: 0;
          background: none;
          border: none;
          padding: 4px;
          cursor: pointer;
          border-radius: var(--radius-sm);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.7;
          transition: opacity var(--transition-fast);
        }

        .toast-close:hover {
          opacity: 1;
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @media (max-width: 576px) {
          .toast-container {
            top: 10px;
            right: 10px;
            left: 10px;
          }

          .toast {
            min-width: auto;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;

